module.exports = __webpack_public_path__ + "static/media/ExpiredPlan.8ddf7824.svg";